import FileUploadeAbstract from 'components/Commun/Form/InputFiles/Model/FileUploadeAbstract';
import usagerClientReducer from '../../../../store/usagerReducer';
import { API_RECUPERER_FICHIER_TELECHARGEMENT } from '../../../../constants/apiUrls.constants';

export default class FileUploadeBack extends FileUploadeAbstract {
    constructor(file) {
        super(file.filename);
        this.uuid = file.uuid;
    }

    async download() {
        const axios = usagerClientReducer.getInstance();
        this.isLoading = true;
        try {
            const response = await axios.get(API_RECUPERER_FICHIER_TELECHARGEMENT + this.uuid);
            const { data } = response.data;
            const url = `data:${data.mimeTypefichier};base64,${data.contenuFichier}`;
            const tempLink = document.createElement('a');
            tempLink.style.display = 'none';
            tempLink.href = url;
            tempLink.setAttribute('download', data.libelleUtilisateur);
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(url);
            this.isLoading = false;
        } catch (error) {
            this.isLoading = false;
        }
    }

    async getFileToSend() {
        return this;
    }
}
